// @owners { team: patients }
import {
  type AttestationRequestItem,
  AttestationRequestsEndpoint,
} from '@alto/scriptdash/alto/patient_app/attestations/v1/attestation_requests_endpoint';
import { apiEndpointHandler } from '~shared/helpers/api';
import { getErrorMessageFromResponse } from '~shared/helpers/helper';

const attestationRequestsEndpoint = AttestationRequestsEndpoint(apiEndpointHandler);

export const fetchAttestationRequestsByDeliveryId = async ({
  deliveryID,
}: {
  deliveryID: number;
}): Promise<AttestationRequestItem[]> => {
  const response = await attestationRequestsEndpoint.index({ delivery_id: deliveryID });

  if (response.errors?.length) {
    throw new Error(getErrorMessageFromResponse({ errors: response.errors ?? undefined }));
  }

  return response.data ?? [];
};
